import { type ConfirmationModalProps, ConfirmationModal, Text } from '@shared/components';

export type ItemSetSubQuestionDeletionModalProps = Pick<
  ConfirmationModalProps,
  'loading' | 'open' | 'onAccept' | 'onClose'
>;

export default function ItemSetSubQuestionDeletionModal(
  props: Readonly<ItemSetSubQuestionDeletionModalProps>,
) {
  const { loading: isLoading, open: isOpen, onClose, onAccept } = props;

  return (
    <ConfirmationModal
      title='Delete Sub-Question?'
      open={isOpen}
      loading={isLoading}
      acceptText='Delete'
      variant='error'
      content={<Text>คุณต้องการลบ Sub-Question นี้ใช่หรือไม่?</Text>}
      onDiscard={onClose}
      onClose={onClose}
      onAccept={onAccept}
    />
  );
}
